import { DiscordCommand } from '../../../../shared/DiscordActivityTypes.ts';
import { AnalyticEventCategory, AnalyticEventType, ReferralTypeEnum, ShareActivityLinkAnalytics } from '../../../../shared/entity_datas/EntityDatas.ts';
import { CA } from '../analytics/Analytics.ts';
import { clientI18n } from '../ClientI18n.ts';
export class DiscordInviteShareHelper {
    static canOpenInviteFriendsDialog(options) {
        if (!options.inDiscordServer) return false;
        if (!options.canInviteFriends) return false;
        return true;
    }
    static inviteFriends(communicationHandler) {
        void communicationHandler.sendMessageToMount({
            command: DiscordCommand.InviteFriends
        });
    }
    static inviteFriendsIfAllowed(communicationHandler, options) {
        if (!DiscordInviteShareHelper.canOpenInviteFriendsDialog(options)) return false;
        DiscordInviteShareHelper.inviteFriends(communicationHandler);
        return true;
    }
    static async shareActivityLink(communicationHandler, data) {
        DiscordInviteShareHelper.sendShareActivityLinkAnalytic(data.analyticsPopupTriggered);
        const result = await communicationHandler.sendMessageToMount({
            command: DiscordCommand.ShareActivityLink,
            data: {
                message: data.message,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                referrer_id: data.referrerId,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                custom_id: data.referralTypeId
            }
        });
        if ((result === null || result === void 0 ? void 0 : result.success) != true) return;
        DiscordInviteShareHelper.sendShareActivityLinkAnalytic(data.analyticsPopupSuccess);
    }
    static getRoomInvitationShareActivityLinkData(roomId) {
        return {
            message: clientI18n.t('strings:homePage.popups.discordRoomInvitationUsingShareActivityLink.text'),
            referralTypeId: `${ReferralTypeEnum.DiscordRoomInvitationUsingShareActivityLink.toString()}+room=${roomId}`,
            analyticsPopupTriggered: ShareActivityLinkAnalytics.RoomInvitationUsingShareActivityLinkPopupTriggered,
            analyticsPopupSuccess: ShareActivityLinkAnalytics.RoomInvitationUsingShareActivityLinkSuccessfullyShared
        };
    }
    static getStoreReferralShareActivityLinkData(referralReward) {
        return {
            message: clientI18n.t('strings:homePage.popups.discordShareActivity.text'),
            referralTypeId: ReferralTypeEnum.DiscordShareActivityReferralProgramStore.toString(),
            analyticsPopupTriggered: referralReward.analyticsPopupTriggered,
            analyticsPopupSuccess: referralReward.analyticsPopupSuccess
        };
    }
    static inviteFriendsOrShareActivityLink(communicationHandler, options) {
        if (DiscordInviteShareHelper.inviteFriendsIfAllowed(communicationHandler, options)) return;
        void DiscordInviteShareHelper.shareActivityLink(communicationHandler, options.shareActivityLinkData);
    }
    static inviteFriendsToRoom(communicationHandler, options) {
        DiscordInviteShareHelper.inviteFriendsOrShareActivityLink(communicationHandler, {
            inDiscordServer: options.inDiscordServer,
            canInviteFriends: options.canInviteFriends,
            shareActivityLinkData: DiscordInviteShareHelper.getRoomInvitationShareActivityLinkData(options.roomId)
        });
    }
    static shareStoreReferral(communicationHandler, referralReward) {
        void DiscordInviteShareHelper.shareActivityLink(communicationHandler, DiscordInviteShareHelper.getStoreReferralShareActivityLinkData(referralReward));
    }
    static sendShareActivityLinkAnalytic(analyticType) {
        const eventData = {
            type: AnalyticEventType.ReferralAnalytics,
            category: AnalyticEventCategory.ShareActivityLink,
            floatValue: analyticType
        };
        void CA.sendAnalyticEvent(eventData);
    }
}
